import { Stack, Label, PrimaryButton, Image, FontIcon } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/pokemon.module.scss';
import { TShoppingCart, TShoppingCartItem, TSize } from '../constants/types';
import { CalculatePrices } from '../helpers/General';
import GlobalContext from '../_contexts/GlobalContext';

export interface IshoppingcartComponentProps {
    satprice: number;
    onSmallCartClick: Function;
    shoppingcart: TShoppingCart;
    onCheckOut: Function;
    showPopup: Function;
    pShowMessage: Function;
    eurprice: number;
    usdprice: number;
}

const Shoppingcart : React.FunctionComponent<IshoppingcartComponentProps> = (props : IshoppingcartComponentProps) => {
    const [sendCost, setsendCost] = useState<number>(6.49);
    const [totalprice, settotalprice] = useState<number>(sendCost);
    const [itemCount, setitemCount] = useState<number>(0);
    const [changed, setchanged] = useState<boolean>(false);

    const { BitcoinEnabled } = useContext(GlobalContext);

    const { Strings, windowSize } = useContext(GlobalContext);

    useEffect(() => {
        preRender();
    }, [props]);

    function removeFromCart(item: TShoppingCartItem) {
        let newArray: TShoppingCartItem[] = [];
        props.shoppingcart.items.forEach(i => {
            if (item.product.id != i.product.id) {
                newArray.push(i);
            }
        });
        props.shoppingcart.items = newArray; //Yuck, TODO. Never change props
        preRender();
        props.pShowMessage(`${item.product.title} ${Strings.RemovedFromCart}`)
    }

    function setAmmount(item: TShoppingCartItem, ammount:number) {
        let filtered = props.shoppingcart.items.filter(i => i.product.id === item.product.id);
        if (ammount <= item.product.available && ammount > 0) {
            if (filtered[0].ammount < ammount) {
                props.pShowMessage(`${filtered[0].product.title} ${Strings.AddedToCart}`, 1000, false);
            } else {
                props.pShowMessage(`${filtered[0].product.title} ${Strings.RemovedFromCart}`, 1000, false);
            }

            filtered[0].ammount = ammount; //Yuck, TODO. Never change props
            preRender();
        } else {
            if (filtered[0].ammount < ammount) {
                props.pShowMessage(Strings.NotAvailable, 2000, true);
            } else {
                props.pShowMessage(Strings.MinimalInCart, 2000, true);
            }
        }
    }

    function preRender() {
        const [_total, _sendcost, _itemCount] = CalculatePrices(props.satprice, props.eurprice, props.usdprice, props.shoppingcart, BitcoinEnabled);
        if (_itemCount != _itemCount) {
            setchanged(true);
            setTimeout(() => {
                setchanged(false);
            }, 500);
        }
        settotalprice(_total);
        setsendCost(_sendcost);
        setitemCount(_itemCount);
    }

    return (   
        windowSize.x > 960 ? 
            <Stack className={styles.winkelwagen} verticalAlign='center'>
                <div className={styles.shoppingCartTitleContainerBig}>
                    <div className={styles.shoppingCartTitle}>
                        {Strings.Shoppingcart}
                    </div>
                </div>
                {itemCount != 0 ?
                    <div>
                        <div className={styles.divTable} style={{maxHeight:windowSize.y-100}}>
                            {props.shoppingcart.items.map(item => {
                                return <div className={styles.divTableRow}>
                                            <div className={styles.divTableCell} style={{verticalAlign:"middle"}}>
                                                <Stack horizontal verticalAlign='center'>
                                                    <FontIcon iconName="Trash" className={styles.delete} onClick={() => { removeFromCart(item); }}/>
                                                </Stack>
                                            </div>
                                            <div className={styles.divTableCell} style={{verticalAlign:"middle"}}>
                                                <Stack horizontal verticalAlign='center'>
                                                    <img className={styles.checkoutCardImg} 
                                                            onClick={() => {props.showPopup(item.product.imageUrls[0]);}}
                                                            src={item.product.imageUrls[0]} alt="" />
                                                    <Label className={styles.shoppingcartAmmount}>{item.product.title}</Label>
                                                </Stack>
                                            </div>
                                            <div className={styles.divTableCell} style={{verticalAlign:"middle"}}>
                                                <Stack horizontal>
                                                    <FontIcon iconName="SkypeCircleMinus" className={styles.minus} onClick={() => { setAmmount(item, item.ammount-1); }}/>
                                                    <Label className={styles.shoppingcartAmmount}>x {item.ammount}</Label>
                                                    <FontIcon iconName="CirclePlus" className={styles.plus} onClick={() => { setAmmount(item, item.ammount+1); }}/>
                                                </Stack>
                                            </div>
                                            <div className={styles.divTableCell} style={{verticalAlign:"middle"}}>
                                                <Stack horizontalAlign='end'>
                                                    <Label>€ {(item.ammount * Math.round(100* item.product.priceInUSD * props.eurprice) / 100).toFixed(2)}</Label>
                                                    {BitcoinEnabled && <Stack horizontal>
                                                                        <Image className={styles.btciconsmallcard}
                                                                            style={{ cursor: "default", paddingTop:4.5 }}
                                                                            src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                                                                        />
                                                                        <Label style={{fontSize:"smaller"}}>{item.ammount * Math.round(item.product.priceInUSD / props.satprice)} sats</Label>
                                                                       </Stack>}
                                                </Stack>
                                            </div>
                                    </div>
                                        
                            })}
                        </div>
                        <hr />
                        <div className={styles.divTable}>                        
                            {itemCount > 0 &&
                            <div className={styles.divTableRow}>
                                <div className={styles.divTableCell}>
                                    <Label>{Strings.SendingCost}</Label>
                                </div>
                                <div className={styles.divTableCell}>
                                </div>
                                <div className={styles.divTableCell}>
                                    <Stack horizontalAlign='end'>
                                        {BitcoinEnabled ? <Label>€ {(Math.round(sendCost * props.satprice * 100 * props.eurprice) / 100).toFixed(2)}</Label>
                                                        : <Label>€ {sendCost}</Label>}
                                        {BitcoinEnabled && <Stack horizontal>
                                                               <Image className={styles.btciconsmallcard}
                                                                   style={{ cursor: "default", paddingTop:4.5 }}
                                                                   src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                                                               />
                                                               <Label style={{fontSize:"smaller"}}>{sendCost} sats</Label>
                                                           </Stack>}
                                    </Stack>
                                </div>
                            </div>}
                            </div>
                        <hr />
                        <div className={styles.divTable}>
                            {itemCount > 0 &&
                            <div className={styles.divTableRow}>
                                <div className={styles.divTableCell}>
                                    <Label>{Strings.Total}</Label>
                                </div>
                                <div className={styles.divTableCell}>
                                </div>
                                <div className={styles.divTableCell}>
                                    <Stack horizontalAlign='end'>
                                        {BitcoinEnabled ? <Label>€ {(Math.round(100 * totalprice * props.satprice * props.eurprice) / 100).toFixed(2)}</Label>
                                                        : <Label>€ {(totalprice).toFixed(2)}</Label>}
                                        {BitcoinEnabled && <Stack horizontal>
                                                               <Image className={styles.btciconsmallcard}
                                                                   style={{ cursor: "default", paddingTop:5 }}
                                                                   src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                                                               />
                                                               <Label style={{fontSize:"smaller"}}>{totalprice} sats</Label>
                                                           </Stack>}
                                    </Stack>
                                </div>
                            </div>}
                        </div>
                    </div>
                : <div className={styles.emptyCartLabel}>{Strings.ShoppingcartEmpty}</div>}
                {BitcoinEnabled && itemCount !== 0 && <Label className={styles.priceWarning}>* {Strings.PaymentNote}</Label>}
                <PrimaryButton disabled={itemCount === 0} className={styles.checkoutButton} text={Strings.CheckOut} onClick={() => {props.onCheckOut();}}>
                    <FontIcon aria-label="Afrekenen" iconName="LightningBolt" />
                </PrimaryButton>
                <Stack horizontalAlign='center'>
                    <a className={styles.keepShoppingLink} onClick={()=>{props.onSmallCartClick();}}>Verder gaan met winkelen</a>
                </Stack>
            </Stack>
        : <div className={`${styles.shoppingCartTitleContainer} ${changed ? styles.added : ""}`}> 
            <Label className={styles.itemCountLabel}>{itemCount}</Label>  
            <FontIcon className={`${styles.shoppingCartIcon}`} iconName={props.shoppingcart.items.length > 0 ? "shoppingcartsolid" : "shoppingcart"} onClick={() => {props.onSmallCartClick(); }}/>
            </div>
    );
}

export default Shoppingcart;